import {LG_WIDTH} from "@main/helpers/const";

const VISIBLE_NUMBER_OF_ITEMS = 8;

class ShowMoreFaqCard {
    constructor(el) {
        this.el = el;
        this.accordionsWrap = this.el.querySelector(".js-cards-wrap");
        this.btn = this.el.querySelector(".js-show-more-faq-btn");
        if (this.btn) {
            this.mount();
            this.listen();
        }
    }

    listen() {
        this.btn.addEventListener("click", this.showMoreFaq);
    }

    mount() {
        const accordions = this.accordionsWrap.querySelectorAll(".js-accordion");

        if (accordions.length > VISIBLE_NUMBER_OF_ITEMS && window.innerWidth < LG_WIDTH) {
            this.accordionsWrap.classList.add("collapsed");
            this.accordionsWrap.nextElementSibling.classList.remove("hidden");
        }   
    }

    showMoreFaq = () => {
        this.accordionsWrap.classList.remove("collapsed");
        this.btn.classList.add("hidden");
    };
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-show-more-faq")
        .forEach(card => new ShowMoreFaqCard(card));
});
